import { Navigate, Route } from "react-router-dom"
import { PrivateRoute } from "@app/components/privateRoute"
import { App } from "@app/interfaces"
import { PostBotResource } from "../components/common/postBotAccess"
import TemplatesPage from "./templatesPage"
import TemplatePage from "./templatePage"
import TemplateVersionPage from "./templateVersionPage"
import TemplateAuthorPage from "./templateAuthorPage"
import PublicationsPage from "./publicationsPage"
import PublicationPage from "./publicationPage"
import PlacementsPage from "./placementsPage"
import PlacementPage from "./placementPage"
import PlacementHistoryPage from "./placementHistoryPage"
import OccurrencePage from "./occurrencePage"
import MediaPage from "./mediaPage"
import ChannelsPage from "./channelsPage"
import DetailedChannelPage from "./detailedChannelPage"

/** Shared by App and route integration tests; not nested under the legacy
 * needModule gate (which intentionally accepts either r or w). */
export function postBotRoutes() {
  return (
    <Route path="post-bot">
      <Route
        element={
          <PrivateRoute
            needRole={App.UserRole.MANAGER}
            accessPolicy={App.AccessPolicy.POST_BOT_READ}
          />
        }
      >
        <Route index element={<Navigate to="publications" replace />} />
        <Route
          path="templates"
          element={<PostBotResource page={TemplatesPage} />}
        />
        <Route
          path="templates/:templateId"
          element={<PostBotResource page={TemplatePage} />}
        />
        <Route
          path="template-versions/:versionId"
          element={<PostBotResource page={TemplateVersionPage} />}
        />
        <Route
          path="publications"
          element={<PostBotResource page={PublicationsPage} />}
        />
        <Route
          path="publications/:publicationId"
          element={<PostBotResource page={PublicationPage} />}
        />
        <Route
          path="placements"
          element={<PostBotResource page={PlacementsPage} />}
        />
        <Route
          path="placements/:placementId"
          element={<PostBotResource page={PlacementPage} />}
        />
        <Route
          path="placements/:placementId/history"
          element={<PostBotResource page={PlacementHistoryPage} />}
        />
        <Route
          path="occurrences/:occurrenceId"
          element={<PostBotResource page={OccurrencePage} />}
        />
        <Route path="media" element={<PostBotResource page={MediaPage} />} />
        <Route
          element={
            <PrivateRoute
              needRole={App.UserRole.MANAGER}
              accessPolicy={App.AccessPolicy.POST_BOT_WRITE}
            />
          }
        >
          <Route
            path="templates/new"
            element={<PostBotResource page={TemplateAuthorPage} />}
          />
          <Route
            path="templates/:templateId/versions/new"
            element={<PostBotResource page={TemplateAuthorPage} />}
          />
          <Route
            path="publications/new"
            element={<PostBotResource page={PublicationPage} />}
          />
          <Route
            path="placements/new"
            element={<PostBotResource page={PlacementPage} />}
          />
        </Route>
      </Route>
      <Route
        element={
          <PrivateRoute
            needRole={App.UserRole.MANAGER}
            needModule={App.ModuleName.POST_BOT}
            redirectTo="/login"
          />
        }
      >
        <Route path="channels" element={<ChannelsPage />} />
        <Route
          path="channels/:channelId"
          element={<PostBotResource page={DetailedChannelPage} />}
        />
      </Route>
    </Route>
  )
}
